import { useAtom } from 'jotai';

import {
  initialNotificationsState,
  NotificationsState,
  notificationsAtom,
} from '@/store/notifications';

const useNotificationsAtom = () => {
  const [notificationsData, setNotificationsData] = useAtom(notificationsAtom);

  const updateNotifications = (updates: Partial<NotificationsState>) => {
    setNotificationsData((prev) => ({
      ...prev,
      ...updates,
    }));
  };

  const resetNotifications = () => {
    setNotificationsData(initialNotificationsState);
  };

  return {
    notificationsData,
    setNotificationsData,
    updateNotifications,
    resetNotifications,
  };
};

export default useNotificationsAtom;
